const Cleave = require('cleave.js').default;

function FieldMask(props) {
  if (!props.el) {
    return;
  }

  const self = props.el;
  const maskType = self.getAttribute('data-mask') || false;
  const maxValues = { ssn: 4, ghpID: 11, zip: 5 };

  function phoneCleave() {
    return maskType === 'phone' && new Cleave(self, {
      numericOnly: true,
      blocks: [3, 3, 4],
      delimiters: ['-', '-', '-']
    });
  }

  function numCleave() {
    return (maskType === 'ssn' || maskType === 'ghpID' || maskType === 'zip') && new Cleave(self, {
      numericOnly: true,
      blocks: [maxValues[maskType]]
    });
  }

  function dateCleave() {
    return maskType === 'date' && new Cleave(self, {
      date: true,
      datePattern: ['m', 'd', 'Y']
    });
  }

  // only proceed if a mask type is provided
  if (maskType) {
    switch (maskType) {
      case 'phone':
        phoneCleave();
        break;

      case 'date':
        dateCleave();
        break;

      case 'ssn':
      case 'ghpID':
      case 'zip':
        numCleave();
        break;

      default:
        // do nothing if unsupported mask type provided
        break;
    }
  }
}

module.exports = FieldMask;
